import { Box, Button, Grid, makeStyles, Typography } from "@material-ui/core";
import { InfoOutlined } from "@material-ui/icons";
import { useEffect, useState } from "react";
import { useStrategySelector } from "src/context/strategyContext";
import useNotify from "src/hooks/useNotify";
import { simulationClient } from "src/services/requestClient";
import { text } from "./config";
import StrategyNumberInput from "./StrategyNumberInput";

const useStyle = makeStyles((theme) => ({
  boxContainer: {
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  action: {
    margin: "0rem 0rem 0rem 1rem",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      margin: "0.5rem 0rem 0rem 0rem",
    },
  },
  butBox: {
    margin: "4rem 4rem 0rem 0rem",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      margin: "0.5rem 0rem 0rem 0rem",
      flexDirection: "column",
    },
  },
  moreInfo: {
    textAlign: "left",
  },
}));

export default function CreditScoreStrategyForm({
  setLoadingChart,
  setSeriesChart,
  setDataChart,
  accountAddress,
  balance,
  setLoadingIcon,
}) {
  const cls = useStyle();
  const { errorNotify } = useNotify();

  const [errorTextField, setErrorTextField] = useState(false);
  const [loadingTextField, setLoadingTextField] = useState(true);
  const [creditScore, setCreditScore] = useState("");

  const checkPlaceHolder = balance < 500 && errorTextField === true;
  const checkErrorTextField = (balance < 500 && errorTextField === true) || errorTextField === true;

  const [disableTextField, setDisableTextField] = useState(true);
  const [hideEditYourParam, setHideEditYourPram] = useState(false);
  const [hideResetYourParam, setHideResetYourPram] = useState(true);
  const [hideEstimateYourCreditScore, setHideEstimateYourCreditScore] = useState(true);
  const [disableEditYourParam, setDisableEditYourParam] = useState(false);
  const [disableEstimateYourCreditScore, setDisableEstimateYourCreditScore] = useState(false);

  const {
    totalAsset,
    liquidationPenalty,
    ratioOfDeposit,
    ratioOfBorrow,
    averageAmount,
    averageNumber,
    ageOfWallet,
    trustworthinessOfPossessingAssets,
    numberOfMonitoringDays,
  } = useStrategySelector((state) => state.data);

  const {
    setTotalAsset,
    setLiquidationPenalty,
    setRatioOfDeposit,
    setRatioOfBorrow,
    setAverageAmount,
    setAverageNumber,
    setAgeOfWallet,
    setTrustworthinessOfPossessingAssets,
    setNumberOfMonitoringDays,
  } = useStrategySelector((state) => state.setData);

  const {
    errorTotalAsset,
    errorLiquidationPenalty,
    errorRatioOfDeposit,
    errorRatioOfBorrow,
    errorAverageAmount,
    errorAverageNumber,
    errorAgeOfWallet,
    errorTrustworthinessOfPossessingAssets,
    errorNumberOfMonitoringDays,
  } = useStrategySelector((state) => state.error);

  useEffect(() => {
    checkDisableEstimateButton();
  }, [
    errorTotalAsset,
    errorLiquidationPenalty,
    errorRatioOfDeposit,
    errorRatioOfBorrow,
    errorAverageAmount,
    errorAverageNumber,
    errorAgeOfWallet,
    errorTrustworthinessOfPossessingAssets,
    errorNumberOfMonitoringDays,
  ]);

  function checkDisableEstimateButton() {
    if (
      errorTotalAsset ||
      errorLiquidationPenalty ||
      errorRatioOfDeposit ||
      errorRatioOfBorrow ||
      errorAverageAmount ||
      errorAverageNumber ||
      errorAgeOfWallet ||
      errorTrustworthinessOfPossessingAssets ||
      errorNumberOfMonitoringDays
    ) {
      setDisableEstimateYourCreditScore(true);
    } else setDisableEstimateYourCreditScore(false);
  }

  const {
    helperTextTotalAsset,
    helperTextLiquidationPenalty,
    helperTextRatioOfDeposit,
    helperTextRatioOfBorrow,
    helperTextAverageAmount,
    helperTextAverageNumber,
    helperTextAgeOfWallet,
    helperTextTrustworthinessOfPossessingAssets,
    helperTextNumberOfMonitoringDays,
  } = useStrategySelector((state) => state.helperText);

  useEffect(() => {
    featDataOfAddress();
  }, [accountAddress]);

  async function featDataOfAddress() {
    try {
      setLoadingTextField(true);
      setLoadingIcon(true);
      const res = await simulationClient.get(`/wallet/${accountAddress}`);
      const dataUser = res.data;
      setTotalAsset(parseFloat(dataUser.total_asset).toFixed(2));
      setLiquidationPenalty(parseFloat(dataUser.liquidation_penalty).toFixed(2));
      setRatioOfDeposit(parseFloat(dataUser.deposit_percent).toFixed(2));
      setRatioOfBorrow(parseFloat(dataUser.borrow_percent).toFixed(2));
      setAverageAmount(parseFloat(dataUser.freq_amount).toFixed(2));
      setAverageNumber(parseFloat(dataUser.freq_time).toFixed(2));
      setAgeOfWallet(parseFloat(dataUser.age).toFixed(2));
      setTrustworthinessOfPossessingAssets(parseFloat(dataUser.trustworthiness_of_possessing_assets).toFixed(2));
      setNumberOfMonitoringDays("30");
      setCreditScore(dataUser.credit_score);
      resetStateAccountInvalid();
      setLoadingTextField(false);
      setLoadingIcon(false);
    } catch (error) {
      resetStateAccountError();
    }
  }

  function resetStateAccountInvalid() {
    setDisableEditYourParam(false);
    setErrorTextField(false);
    setDisableEstimateYourCreditScore(false);
    setLoadingChart(true);
  }

  function resetStateAccountError() {
    setLoadingIcon(false);
    setDisableTextField(true);
    setDisableEstimateYourCreditScore(true);
    setDisableTextField(true);
    setDisableEditYourParam(true);
    setHideEditYourPram(false);
    setHideResetYourPram(true);
    setHideEstimateYourCreditScore(true);
    setErrorTextField(true);
    setLoadingTextField(false);
    setLoadingChart(true);
  }

  function handleResetYourParam() {
    featDataOfAddress();
    setHideEditYourPram(false);
    setHideResetYourPram(true);
    setHideEstimateYourCreditScore(true);
    setDisableTextField(true);
    setLoadingChart(true);
  }

  function handleEditYourParam() {
    if (balance < 500) {
      errorNotify("This feature is only available for users holding more than 500 TRAVA");
    } else {
      setDisableTextField(false);
      setHideEditYourPram(true);
      setHideResetYourPram(false);
      setHideEstimateYourCreditScore(false);
    }
  }

  async function handleEstimateYourCreditScore() {
    setLoadingChart(false);
    const res = await simulationClient.get(`/credit-score/${accountAddress}`, {
      params: {
        total_asset: totalAsset ? totalAsset : 1000,
        freq_time: averageNumber ? averageNumber : 2,
        freq_amount: averageAmount ? averageAmount : 330,
        deposit_percent: ratioOfDeposit ? ratioOfDeposit : 80,
        borrow_percent: ratioOfBorrow ? ratioOfBorrow : 50,
        days_of_statistics: numberOfMonitoringDays ? numberOfMonitoringDays : 30,
        age: ageOfWallet ? ageOfWallet : 100,
        trustworthiness_of_possessing_assets: trustworthinessOfPossessingAssets
          ? trustworthinessOfPossessingAssets
          : 800,
        liquidation_penalty: liquidationPenalty ? liquidationPenalty : 0,
      },
    });
    const data = res.data;
    let dataChart = data.timestamps.map((item, index) => [item, data?.credit_scores[index]]);
    setDataChart(data);
    setSeriesChart(dataChart);
    setLoadingChart(false);
  }

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item xs={12} md={12}>
          <Box display="flex" alignItems="center" justifyContent="flex-start">
            <InfoOutlined style={{ marginRight: "0.25rem", fontSize: "16px" }} />
            <Typography style={{ fontSize: "14px" }}>
              Holding more than 500 TRAVA (aggregated on multiple chains), you can adjust your following parameters to
              see how your credit score changes
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <StrategyNumberInput
            title={text[0].label}
            info={text[0].info}
            value={errorTextField ? "" : loadingTextField ? "loading..." : totalAsset}
            onChange={(ev) => setTotalAsset(ev.target.value)}
            error={errorTotalAsset}
            helperText={helperTextTotalAsset}
            disabled={disableTextField}
            placeholder={checkPlaceHolder ? "" : "ex: 1000"}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <StrategyNumberInput
            title={text[1].label}
            info={text[1].info}
            value={errorTextField ? "" : loadingTextField ? "loading..." : liquidationPenalty}
            onChange={(ev) => setLiquidationPenalty(ev.target.value)}
            disabled={disableTextField}
            helperText={helperTextLiquidationPenalty}
            placeholder={checkPlaceHolder ? "" : "ex: 0"}
            error={errorLiquidationPenalty}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <StrategyNumberInput
            title={text[2].label}
            info={text[2].info}
            value={errorTextField ? "" : loadingTextField ? "loading..." : ratioOfDeposit}
            onChange={(ev) => setRatioOfDeposit(ev.target.value)}
            disabled={disableTextField}
            helperText={helperTextRatioOfDeposit}
            placeholder={checkPlaceHolder ? "" : "ex: 80"}
            error={errorRatioOfDeposit}
            InputProps={{
              StartAdornment: (
                <>
                  {totalAsset && ratioOfDeposit && balance > 500 && !errorTextField && !loadingTextField ? (
                    <Typography className="target ml-9">
                      Deposit : ${((parseFloat(totalAsset) * parseFloat(ratioOfDeposit)) / 100).toFixed(2)}
                    </Typography>
                  ) : null}
                </>
              ),
            }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <StrategyNumberInput
            title={text[3].label}
            info={text[3].info}
            value={errorTextField ? "" : loadingTextField ? "loading..." : ratioOfBorrow}
            onChange={(ev) => setRatioOfBorrow(ev.target.value)}
            disabled={disableTextField}
            helperText={helperTextRatioOfBorrow}
            placeholder={checkPlaceHolder ? "" : "ex: 50"}
            error={errorRatioOfBorrow}
            InputProps={{
              StartAdornment: (
                <>
                  {ratioOfDeposit && ratioOfBorrow && balance > 500 && !errorTextField && !loadingTextField ? (
                    <Typography>
                      Borrow : $
                      {((((parseFloat(totalAsset) * parseFloat(ratioOfDeposit)) / 100) * ratioOfBorrow) / 100).toFixed(
                        2
                      )}
                    </Typography>
                  ) : null}
                </>
              ),
            }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <StrategyNumberInput
            title={text[4].label}
            info={text[4].info}
            value={errorTextField ? "" : loadingTextField ? "loading..." : averageAmount}
            onChange={(ev) => setAverageAmount(ev.target.value)}
            disabled={disableTextField}
            helperText={helperTextAverageAmount}
            placeholder={checkPlaceHolder ? "" : "ex: 330"}
            error={errorAverageAmount}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <StrategyNumberInput
            title={text[5].label}
            info={text[5].info}
            value={errorTextField ? "" : loadingTextField ? "loading..." : averageNumber}
            onChange={(ev) => setAverageNumber(ev.target.value)}
            disabled={disableTextField}
            helperText={helperTextAverageNumber}
            placeholder={checkPlaceHolder ? "" : "ex: 2"}
            error={errorAverageNumber}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <StrategyNumberInput
            title={text[6].label}
            info={text[6].info}
            value={errorTextField ? "" : loadingTextField ? "loading..." : ageOfWallet}
            onChange={(ev) => setAgeOfWallet(ev.target.value)}
            disabled={disableTextField}
            helperText={helperTextAgeOfWallet}
            placeholder={checkPlaceHolder ? "" : "ex: 1000"}
            error={errorAgeOfWallet}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <StrategyNumberInput
            title={text[7].label}
            info={text[7].info}
            value={errorTextField ? "" : loadingTextField ? "loading..." : trustworthinessOfPossessingAssets}
            onChange={(ev) => setTrustworthinessOfPossessingAssets(ev.target.value)}
            disabled={disableTextField}
            helperText={helperTextTrustworthinessOfPossessingAssets}
            placeholder={checkPlaceHolder ? "" : "ex: 100"}
            error={errorTrustworthinessOfPossessingAssets}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <StrategyNumberInput
            title={text[8].label}
            info={text[8].info}
            value={errorTextField ? "" : loadingTextField ? "loading..." : numberOfMonitoringDays}
            onChange={(ev) => setNumberOfMonitoringDays(ev.target.value)}
            disabled={disableTextField}
            helperText={helperTextNumberOfMonitoringDays}
            placeholder={checkPlaceHolder ? "" : "ex: 30"}
            error={errorNumberOfMonitoringDays}
          />
        </Grid>
      </Grid>
      <Box className={cls.butBox}>
        {checkErrorTextField ? (
          <Typography style={{ color: "#d2374e" }} className={cls.moreInfo}>
            As your wallet is new to us, your parameters are temporarily unavailable. We will analyze your data in a few
            minutes!
          </Typography>
        ) : (
          <Typography className={cls.moreInfo}>Your current credit score: {creditScore}</Typography>
        )}
        <Box className={cls.boxContainer}>
          {hideEditYourParam ? null : (
            <Button
              color="primary"
              disabled={disableEditYourParam}
              variant="contained"
              className={cls.action}
              onClick={handleEditYourParam}
            >
              Edit your Param
            </Button>
          )}
          {hideResetYourParam ? null : (
            <Button color="primary" variant="contained" className={cls.action} onClick={handleResetYourParam}>
              Reset your params
            </Button>
          )}
          {hideEstimateYourCreditScore ? null : (
            <Button
              color="primary"
              variant="contained"
              disabled={disableEstimateYourCreditScore}
              className={cls.action}
              onClick={handleEstimateYourCreditScore}
            >
              Estimate your credit score
            </Button>
          )}
        </Box>
      </Box>
    </Box>
  );
}
